import { CognitoIdentityProviderClient, GetUserCommand } from '@aws-sdk/client-cognito-identity-provider';
import aws from '../../utils/aws';
import config from '../../config/config';

export const USER_ATTRIBUTES_SUCCESS = 'USER_DATA/USER_ATTRIBUTES_SUCCESS';

export function getUserAttributes(dispatch) {
    const client = new CognitoIdentityProviderClient({ region: config.cognito.REGION });

    return aws.getCurrentUserTokens().then((userTokens) => {
        return client.send(new GetUserCommand({ AccessToken: userTokens.accessToken }))
            .then((data) => {
                dispatch({
                    type: USER_ATTRIBUTES_SUCCESS,
                    userAttributes: data.UserAttributes
                });
            })
            .catch((error) => {
                console.error(error);
            });
    });
}
